@if (!isLoading) {
  <div class="main">
    <img [src]="'../../../assets/images/accountOn-icon.png'" alt="accountOn" />
    <div class="box">
      <div class="box-title">{{ title }}</div>
      <div class="box-body">
        <i class="fa fa-download custom-icon" aria-hidden="true"></i> <br />
        @if (isSuccess) {
          <span class="body-text"
            >{{ "contract-download.You_will_be_redirected_to_dashborad_after_5_seconds_or" | translate
            }}<a (click)="redirect()" class="c-p">{{ "contract-download.redirect" | translate }}</a
            >{{ "contract-download.now" | translate }}</span
          >
        }
      </div>
    </div>
  </div>
}
@if (isLoading) {
  <div style="display: flex; justify-content: center; align-items: center; height: 100%" id="initial_loader">
    <div class="lds-ellipsis">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
}
